import React, { useCallback } from 'react';
import type { InsuranceType } from '~/@types/insurance';
import type { RootStackParamList } from '~/navigation/types';
import Button from '../Button';
import useAppNavigation from '~/hooks/useAppNavigation';
import useHeader from '~/hooks/useHeader';
import { MarisaAppUtils } from '~/utils/MarisaAppUtils';

interface Props {
  type: InsuranceType;
  buttonLabel: string;
  navigateTo: keyof RootStackParamList;
  disabled?: boolean;
}

const ContinueToContractButton: React.FC<Props> = ({
  type,
  buttonLabel,
  navigateTo,
  disabled,
}) => {
  const { navigate } = useAppNavigation();
  const { isLoggedIn } = useHeader();

  const onContinue = useCallback(() => {
    if (['totem', 'crediario'].includes(MarisaAppUtils.origin) && !isLoggedIn) {
      navigate('MarisaServicos_NoAuthContractPage', {
        type,
        navigateTo,
      });
    } else {
      navigate(navigateTo as any);
    }
  }, [isLoggedIn, navigate, navigateTo, type]);

  return (
    <Button
      className="w-full xs:w-auto"
      onPress={disabled ? () => null : onContinue}
    >
      {disabled ? 'Em breve em nossas lojas' : buttonLabel}
    </Button>
  );
};

export default ContinueToContractButton;
